export const addToSpendingHistoryTurnAmts = (turnAmtArr, spendAmt) => {
    let spendIndx = 0;
    if (!turnAmtArr){
        turnAmtArr = [0];
    }else{
        if (turnAmtArr.length > 0){
            spendIndx = turnAmtArr.length - 1;
        }
    }
    turnAmtArr[spendIndx] =
        (+turnAmtArr[spendIndx] + +spendAmt).toString();
    
    return turnAmtArr;

}
export default addToSpendingHistoryTurnAmts;    